import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from '@bonanza-social/toolkit/state';
import {
  fetchBanners,
  selectUserBanners,
  selectBannersDataState,
} from '../state/Banners.slice';

const useBanners = () => {
  const dispatch = useDispatch();
  const banners = useSelector(selectUserBanners);
  const bannersDataState = useSelector(selectBannersDataState);
  const returnObj = useMemo(
    () => ({
      banners,
      bannersDataState,
    }),
    [banners, bannersDataState],
  );

  useEffect(() => {
    if (bannersDataState === 'idle') {
      dispatch(fetchBanners());
    }
  }, [bannersDataState, dispatch]);

  return returnObj;
};

export default useBanners;
